const perView = document.querySelector(".js-swiper").dataset.perview;
const gapSize = document.querySelector(".js-swiper").dataset.gapsize;

var swiper = new Swiper(".swiper-container", {
  // Parameters
  slidesPerView: 3,
  spaceBetween: 20,
  loop: true,
  freemode: true,
  clickable: false,
  draggable: false,
  speed: 5000,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  breakpoints: {
    750: {
      slidesPerView: 6,
      spaceBetween: 20,
    },
  },
});
